export const notification = {
    file:{
        dragName:"ลากหรือเลือกไฟล์เพื่ออัปโหลด",
        formatImg:"อัพโหลดไฟล์ขนาดไม่เกิน 10mb",
        deleteStatus:"ลบสถานะ"
    }
}